import { styled } from '@porsche-code/kado-styled-system/jsx';
import { PText } from '@porsche-design-system/components-react';

export const Paragraph = styled(
  PText,
  {
    base: {
      marginBottom: 'md',
    },
  },
  { forwardProps: ['color'] },
);
